(function () {
  const IMGBB_KEY = '2a443fbf29fc8454aa46d0e0c311e3e3'; // ← replace this

  function initUpload(fileId, statusId, urlFieldId) {
    const fileInput = document.getElementById(fileId);
    const statusEl  = document.getElementById(statusId);
    const urlField  = document.getElementById(urlFieldId);

    if (!fileInput || !statusEl || !urlField) return;

    // Show existing upload if already on cart
    if (urlField.value) {
      statusEl.innerHTML = `✓ Prescription on file — <a href="${urlField.value}" target="_blank" style="text-decoration:underline;">view</a>`;
    }

    fileInput.addEventListener('change', async function (e) {
      const file = e.target.files[0];
      if (!file) return;

      statusEl.textContent = 'Uploading…';

      const formData = new FormData();
      formData.append('image', file);
      formData.append('key', IMGBB_KEY);

      try {
        const res  = await fetch('https://api.imgbb.com/1/upload', { method: 'POST', body: formData });
        const data = await res.json();

        if (data.success) {
          urlField.value = data.data.url;
          statusEl.innerHTML = `✓ Uploaded — <a href="${data.data.url}" target="_blank" style="text-decoration:underline;">view file</a>`;
        } else {
          statusEl.textContent = 'Upload failed. Please try again.';
        }
      } catch (err) {
        statusEl.textContent = 'Error uploading. Please try again.';
      }
    });
  }

  function initMedicalAidRequired() {
    const toggle = document.getElementById('ma-toggle');
    if (!toggle) return;
    const fields = document.querySelectorAll('.ma-field');

    function syncRequired() {
      fields.forEach(function (field) {
        if (toggle.checked) {
          field.setAttribute('required', '');
        } else {
          field.removeAttribute('required');
        }
      });
    }

    toggle.addEventListener('change', syncRequired);
    syncRequired();
  }

  document.addEventListener('DOMContentLoaded', function () {
    // dialog:open is dispatched on the element itself (bubbles: false), so we listen there directly
    const drawer = document.querySelector('cart-drawer-component');
    if (drawer) {
      drawer.addEventListener('dialog:open', function () {
        initUpload('rx-file-drawer', 'rx-status-drawer', 'rx-url-drawer');
        initMedicalAidRequired();
      });
    }
  });
})();
